import React from 'react';
import { Spin as AntSpin, SpinProps as AntSpinProps } from 'antd';
import { createUseStyles } from 'react-jss';
import { ThemeType } from 'src/theming/jssTypes';

export interface SpinProps extends AntSpinProps {
  className?: string;
}

const useStyles = createUseStyles((theme: ThemeType) => ({
  spin: {
    color: theme.color.semantic.text.primary,
    '& .ant-spin-dot-item': {
      backgroundColor: theme.color.semantic.brand.default.primary,
    },
    '&.ant-spin-nested-loading > div > .ant-spin': {
      maxHeight: 'initial',
    },
  },
}));

const Spin: React.FC<SpinProps> = ({ className = '', ...rest }) => {
  const classes = useStyles();
  return <AntSpin {...rest} className={`${classes.spin} ${className}`.trim()} />;
};

export default Spin;
